import { apiClient } from './apiClient';
import {
  ITravelerProfile,
  IProfileArchetype,
  CreateProfileDto,
  UpdateProfileDto
} from '../../types/profile.types';

/** Unwrap the { success, message, data } envelope returned by the profile API */
function unwrap<T>(response: { data: { data: T } }): T {
  return response.data.data;
}

const profileService = {
  async getMyProfiles(): Promise<ITravelerProfile[]> {
    const response = await apiClient.get<{ data: ITravelerProfile[] }>(
      '/profiles'
    );
    return unwrap(response);
  },

  async getDefaultProfile(): Promise<ITravelerProfile> {
    const response = await apiClient.get<{ data: ITravelerProfile }>(
      '/profiles/default'
    );
    return unwrap(response);
  },

  async getProfileById(id: string): Promise<ITravelerProfile> {
    const response = await apiClient.get<{ data: ITravelerProfile }>(
      `/profiles/${id}`
    );
    return unwrap(response);
  },

  async createProfile(dto: CreateProfileDto): Promise<ITravelerProfile> {
    const response = await apiClient.post<{ data: ITravelerProfile }>(
      '/profiles',
      dto
    );
    return unwrap(response);
  },

  async updateProfile(
    id: string,
    dto: UpdateProfileDto
  ): Promise<ITravelerProfile> {
    const response = await apiClient.put<{ data: ITravelerProfile }>(
      `/profiles/${id}`,
      dto
    );
    return unwrap(response);
  },

  async deleteProfile(id: string): Promise<void> {
    await apiClient.delete(`/profiles/${id}`);
  },

  async setDefaultProfile(id: string): Promise<ITravelerProfile> {
    const response = await apiClient.put<{ data: ITravelerProfile }>(
      `/profiles/${id}/default`
    );
    return unwrap(response);
  },

  async getArchetypes(): Promise<IProfileArchetype[]> {
    const response = await apiClient.get<{ data: IProfileArchetype[] }>(
      '/profiles/archetypes'
    );
    return unwrap(response);
  },

  async createFromArchetype(
    archetypeId: string,
    name: string,
    customizations?: object
  ): Promise<ITravelerProfile> {
    const response = await apiClient.post<{ data: ITravelerProfile }>(
      '/profiles/from-archetype',
      {
        archetypeId,
        name,
        ...customizations
      }
    );
    return unwrap(response);
  }
};

export default profileService;
